import { useCallback, useEffect, useState } from 'react'
import useQuestionSettingsField from '@v4/hooks/questions/useQuestionSettingsField'
import useStyles from './Text.styled'
import { LINE_TYPE } from './Text.const'

export const useText = ({ onClick, pending, justify, withBgImage, answers }) => {
	const defaultValue = useQuestionSettingsField('default')
	const lineType = useQuestionSettingsField('line_type')
	const maxChar = useQuestionSettingsField('max_char')
	const [value, setValue] = useState(() => _.get(answers, [0, 'answer']) ?? defaultValue ?? '')
	const classes = useStyles({ withBgImage })

	const handleChange = useCallback(event => {
		setValue(event.target.value)
	}, [])

	const handleSubmit = useCallback(() => {
		onClick?.({ answer: value })
	}, [onClick, value])

	useEffect(() => {
		const handleKeyUp = event => {
			if (event.key === 'Enter' && event.target.nodeName !== 'TEXTAREA') {
				handleSubmit()
			}
		}

		document.addEventListener('keyup', handleKeyUp)
		return () => {
			document.removeEventListener('keyup', handleKeyUp)
		}
	}, [handleSubmit])

	return [
		{
			classes,
			multiline: lineType === LINE_TYPE.multiLine,
			maxChar,
			justify,
			pending,
			value,
			amount: `${value.length}/${maxChar}`,
			withBgImage,
		},
		{ handleSubmit, handleChange },
	]
}
